import { ReactNode } from 'react';
import { LeftNav } from './LeftNav';
import { Header } from './Header';
import type { NavSection } from '../../types';

interface AppLayoutProps {
  children: ReactNode;
  activeSection?: NavSection;
  onSectionChange?: (section: NavSection) => void;
  showNavigation?: boolean;
  showHeader?: boolean;
  projectId?: string | null;
}

export function AppLayout({ 
  children, 
  activeSection = 'welcome',
  onSectionChange,
  showNavigation = true,
  showHeader = true,
  projectId,
}: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {showHeader && <Header />}
      <div className="flex">
        {showNavigation && (
          <LeftNav 
            activeSection={activeSection}
            onSectionChange={onSectionChange || (() => {})}
            projectId={projectId}
          />
        )}
        <main className="flex-1 overflow-x-hidden">
          <div className={showHeader ? 'h-[calc(100vh-73px)] overflow-y-auto' : 'h-screen overflow-y-auto'}>
          {children}
          </div>
        </main>
      </div>
    </div>
  );
}
